
import { css } from 'lit';
export default css`
.three-up-grid {
  width: 100%;
}

.three-up-grid__eyebrow {
  margin-bottom: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(117, 118, 119, var(--tw-text-opacity));
}

.three-up-grid__list {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 1.5rem;
}

@media (min-width: 640px) {

  .three-up-grid__list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {

  .three-up-grid__list {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .three-up-grid__list {
    row-gap: 3rem;
  }
}

.three-up-grid--icon-card .three-up-grid__eyebrow {
  margin-bottom: 4rem;
}

.three-up-grid--icon-card .three-up-grid__list {
  row-gap: 5rem;
}

.three-up-grid--icon-card .three-up-grid__list {
    -moz-column-gap: 1.5rem;
         column-gap: 1.5rem;
}

@media (min-width: 768px) {

  .three-up-grid--icon-card .three-up-grid__list {
      -moz-column-gap: 2.5rem;
           column-gap: 2.5rem;
  }
}

.three-up-grid--search-panel .three-up-grid__list {
    gap: 36px;
  }

@media (min-width: 1024px) {

  .three-up-grid--search-panel .three-up-grid__list {
    gap: 1.5rem;
  }
}

.three-up-grid--location-card-grid .three-up-grid__list {
    gap: 2.625rem;
    row-gap: 2.5rem;
  }
`;